import React from 'react';
import { Tooltip as TooltipNew } from './Tooltip';
import { convertOldTooltipProps } from './converter.old';
import type { OldTooltipProps } from './converter.old';

export type TooltipProps = OldTooltipProps;

export const Tooltip = (props: TooltipProps) => <TooltipNew {...convertOldTooltipProps(props)} />;
